import React from "react"
import Nav from './Nav'
import { Eventcalendar, toast } from '@mobiscroll/react5'
import dividendInfo from '../dataset/dividend.json'
import { stockName } from "../Helper"

const color = (type) => {
    switch (type) {
        case '權息':
            return '#c49000'
        case '權':
            return '#fbc02d'
        default:
            return '#fff263'
    }
}

export const dividendContent = (d) => {
    let content = (d.stock > 0 ? '權 ' + d.stock + ' ' : '')
    content += (d.cash > 0 ? '息 ' + d.cash : '')
    if (content === '') {
        content = '尚未公布'
    }
    return content
}

const DividendCalendar = ({ theme, onClose }) => {

    const data = dividendInfo.map(d => {

        return ({
            start: new Date(d.date),
            title: d.id + ' ' + stockName(d.id) + ' 除' + d.type,
            color: color(d.type),
            content: dividendContent(d)
        })
    })

    const onEventClick = (event) => {
        toast({
            message: event.event.title
        })
    }

    const renderEvent = (data) => {
        const event = data.original
        return (
            <div className="d-flex" style={{ margin: -16 }}>
                <div className="m-1" style={{ width: '0.5rem', backgroundColor: event.color }}></div>
                <div className="flex-grow-1 p-2">
                    <div className="font-weight-bold">{event.title}</div>
                    <div className="text-muted">{event.content}</div>
                </div>
            </div>
        )
    }

    const txtColor = theme === 'dark' ? '#ffffff' : '#000000'

    return (
        <>
            <Nav theme={theme} title="除權息行事曆" onBack={onClose} />
            <Eventcalendar
                renderEvent={renderEvent}
                view={{
                    calendar: { type: 'month' },
                    agenda: { type: 'month' }
                }}
                data={data}
                onEventClick={onEventClick}
            />
            <div className="text-right fixed-bottom" style={{ color: txtColor, fontSize: '0.75rem' }}>資料來源:證交所網站</div>
        </>)
}

export default DividendCalendar